import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class TailorsWorkshopBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.TAILORS_WORKSHOP;
}

export default TailorsWorkshopBuildingTileEntity;
